/* Mome bundle picker (Eurus) – used by sections/mome-bundle-travel.liquid.
   Each dress has a "Choose dress" button that opens a popup of products
   (from that dress block's collection or product list). Picking one loads its
   photo, name, price and size buttons. Optional rule: a different style for each
   dress (style = text before " in " in the product title). */
(function () {
  if (!window.customElements || customElements.get('mome-bundle-picker')) return;

  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    var fmt = format || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function delim(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(re);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delim(cents, 2, ' ', ','); break;
      default: value = delim(cents, 2, ',', '.');
    }
    return fmt.replace(re, value);
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function firstAvailable(p) {
    if (!p || !p.variants.length) return null;
    return p.variants.find(function (v) { return v.available; }) || p.variants[0];
  }
  function lowestPrice(p) {
    var v = firstAvailable(p);
    return v ? v.price : 0;
  }
  function joinList(items) {
    if (items.length < 2) return items.join('');
    return items.slice(0, -1).join(', ') + ' & ' + items[items.length - 1];
  }
  function styleKey(p) { return (p && p.style ? p.style : '').trim().toLowerCase(); }

  class MomeBundlePicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      var d = this.dataset;
      this.discount = parseFloat(d.discount) || 0;
      this.unique = d.unique === 'true';
      this.fmt = d.moneyFormat;
      this.t = {
        soldOut: d.soldOut || 'Sold out',
        chooseDress: d.chooseDress || 'Choose [items].',
        chooseSize: d.chooseSize || 'Choose a size for [items].',
        save: d.saveTemplate || 'You save [amount] · [percent]% off',
        chosenFor: d.chosenFor || 'In [slot]',
        selected: d.selectedText || 'Selected',
        success: d.success || 'Added to your cart.',
        viewCart: d.viewCart || 'View cart',
        error: d.errorText || 'We couldn’t add your bundle. Please try again.',
        empty: d.emptyText || 'No dresses to show yet.'
      };

      this.button = this.querySelector('[data-role="add"]');
      this.out = {
        compare: this.querySelector('[data-role="compare"]'),
        price: this.querySelector('[data-role="price"]'),
        save: this.querySelector('[data-role="save"]'),
        note: this.querySelector('[data-role="note"]'),
        status: this.querySelector('[data-role="status"]')
      };

      this.slots = Array.prototype.map.call(this.querySelectorAll('[data-slot]'), function (node, i) {
        var s = {
          node: node, index: i,
          listId: node.dataset.list,
          label: node.dataset.label || ('Dress ' + (i + 1)),
          popupTitle: node.dataset.popupTitle || node.dataset.label || '',
          product: null, variant: null,
          box: {
            empty: node.querySelector('[data-role="empty"]'),
            choose: node.querySelector('[data-role="choose"]'),
            chosen: node.querySelector('[data-role="chosen"]'),
            change: node.querySelector('[data-role="change"]'),
            actions: node.querySelector('[data-role="slot-actions"]'),
            view: node.querySelector('[data-role="slot-view"]'),
            sizeWrap: node.querySelector('[data-role="size-wrap"]'),
            sizes: node.querySelector('[data-role="sizes"]')
          }
        };
        [s.box.choose, s.box.change].forEach(function (b) {
          if (b) b.addEventListener('click', function (e) { e.preventDefault(); self.openPopup(s, b); });
        });
        if (s.box.view) s.box.view.addEventListener('click', function (e) {
          if (s.product) self.openQuickView(s.product.id, s, e.currentTarget);
        });
        if (s.box.chosen) s.box.chosen.addEventListener('click', function (e) {
          if (!e.target.closest('a') || !s.product) return;
          e.preventDefault();
          self.openQuickView(s.product.id, s, e.target.closest('a'));
        });
        return s;
      });

      this.setupModal();
      this.slots.forEach(function (s) { self.renderSlot(s); });
      this.update();
      if (this.button) this.button.addEventListener('click', function (e) { e.preventDefault(); self.addToCart(); });
    }

    disconnectedCallback() {
      if (this.modal && this.modal.parentNode === document.body) this.modal.remove();
    }

    /* ---------- popup ---------- */
    setupModal() {
      var self = this;
      this.products = {};
      this.modal = this.querySelector('[data-role="modal"]');
      this.qv = this.querySelector('[data-role="qv"]');
      if (!this.modal) { console.error('[Mome bundle] Popup markup is missing. Check that sections/mome-travel-bundle.liquid is the latest version.'); return; }
      if (!this.modal.querySelector('[data-pick]') && !this.modal.querySelector('[data-role="empty-list"]')) console.warn('[Mome bundle] The popup has no dresses. Check that snippets/mome-bundle-pick-item.liquid is uploaded and each Dress block has a collection or products.');
      /* Move the popups to the end of <body> so no theme container can trap them under other layers */
      document.body.appendChild(this.modal);
      if (this.qv) document.body.appendChild(this.qv);
      this.modalTitle = this.modal.querySelector('[data-role="modal-title"]');

      this.modal.querySelectorAll('[data-pick]').forEach(function (pick) {
        var data;
        try { data = JSON.parse(pick.querySelector('script[data-pick-json]').textContent); } catch (e) { return; }
        if (!self.products[data.id]) self.products[data.id] = { data: data, picks: [] };
        self.products[data.id].picks.push(pick);
        pick.querySelector('[data-role="pick-choose"]').addEventListener('click', function () {
          if (self.activeSlot) self.choose(self.activeSlot, data.id);
        });
        pick.querySelector('[data-role="pick-view"]').addEventListener('click', function (e) {
          self.openQuickView(data.id, self.activeSlot, e.currentTarget);
        });
        /* Like the Signature Set: tapping the photo or name opens the quick view instead of leaving the page */
        pick.querySelector('[data-pick-card]').addEventListener('click', function (e) {
          var a = e.target.closest('a');
          if (!a) return;
          e.preventDefault();
          self.openQuickView(data.id, self.activeSlot, a);
        });
      });

      this.modal.querySelectorAll('[data-role="modal-close"]').forEach(function (b) {
        b.addEventListener('click', function () { self.closePopup(); });
      });
      this.modal.addEventListener('keydown', function (e) { self.trapKeys(e, self.modal, function () { self.closePopup(); }); });

      if (this.qv) {
        this.qvBody = this.qv.querySelector('[data-role="qv-body"]');
        this.qvChoose = this.qv.querySelector('[data-role="qv-choose"]');
        this.qvNote = this.qv.querySelector('[data-role="qv-note"]');
        this.qv.querySelectorAll('[data-role="qv-close"]').forEach(function (b) {
          b.addEventListener('click', function () { self.closeQuickView(); });
        });
        this.qv.addEventListener('keydown', function (e) { self.trapKeys(e, self.qv, function () { self.closeQuickView(); }); });
        if (this.qvChoose) this.qvChoose.addEventListener('click', function () {
          if (self.qvSlot && self.qvProduct) { var id = self.qvProduct; self.closeQuickView(true); self.choose(self.qvSlot, id); }
        });
      }
    }
    trapKeys(e, root, close) {
      if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(root.querySelectorAll('a[href], button:not(:disabled)'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    pickState(p, s) {
      var taken = this.takenBy(p, s);
      var soldOut = !p.variants.some(function (v) { return v.available; });
      var isCurrent = !!(s && s.product && s.product.id === p.id);
      var note = '';
      if (isCurrent) note = this.t.selected;
      else if (soldOut) note = this.t.soldOut;
      else if (taken) note = this.t.chosenFor.replace('[slot]', taken.label);
      return { blocked: !!taken || soldOut, current: isCurrent, note: note };
    }
    takenBy(product, slot) {
      if (!this.unique) return null;
      var key = styleKey(product);
      if (!key) return null;
      return this.slots.find(function (o) { return o !== slot && o.product && styleKey(o.product) === key; }) || null;
    }
    openPopup(s, opener) {
      if (!this.modal) return;
      var self = this;
      this.activeSlot = s;
      this.opener = opener;
      if (this.modalTitle) this.modalTitle.textContent = s.popupTitle;
      var list = null;
      var emptyList = this.modal.querySelector('[data-role="empty-list"]');
      if (emptyList) emptyList.hidden = true;
      this.modal.querySelectorAll('[data-list]').forEach(function (g) {
        var on = g.dataset.list === s.listId;
        g.hidden = !on;
        if (on) list = g;
      });
      if (!list) {
        /* No dresses for this Dress block: say so instead of doing nothing */
        console.warn('[Mome bundle] No dress list found for', s.label, '- pick a collection or products in this Dress block.');
        list = this.modal.querySelector('[data-role="empty-list"]');
        if (list) list.hidden = false;
      }
      if (!list) return;
      this.activeList = list;
      list.querySelectorAll('[data-pick]').forEach(function (pick) {
        var entry = self.products[pick.dataset.pid];
        if (!entry) return;
        var st = self.pickState(entry.data, s);
        pick.classList.toggle('is-selected', st.current);
        pick.classList.toggle('is-blocked', st.blocked);
        var note = pick.querySelector('[data-role="pick-note"]');
        note.textContent = st.note;
        note.hidden = !st.note;
        pick.querySelector('[data-role="pick-choose"]').disabled = st.blocked;
      });
      this.modal.hidden = false;
      document.documentElement.classList.add('mbp-lock');
      var body = this.modal.querySelector('.mbp-modal__body');
      requestAnimationFrame(function () {
        self.modal.classList.add('is-open');
        var cur = list.querySelector('.mbp-pick.is-selected');
        if (body) body.scrollTop = cur ? Math.max(0, cur.offsetTop - 16) : 0;
        var target = (cur && cur.querySelector('[data-role="pick-choose"]')) || list.querySelector('[data-role="pick-choose"]:not(:disabled)') || self.modal.querySelector('[data-role="modal-close"]');
        if (target) target.focus({ preventScroll: true });
      });
    }
    openQuickView(pid, slot, opener) {
      var entry = this.products[pid];
      if (!this.qv || !entry) return;
      var tpl = entry.picks[0].querySelector('template[data-pick-qv]');
      if (!tpl) return;
      this.qvSlot = slot || this.activeSlot;
      this.qvProduct = pid;
      this.qvOpener = opener;
      this.qvBody.innerHTML = '';
      this.qvBody.appendChild(tpl.content.cloneNode(true));
      var st = this.pickState(entry.data, this.qvSlot);
      var foot = this.qvChoose && this.qvChoose.parentElement;
      if (foot) foot.hidden = !this.qvSlot;
      if (this.qvChoose) this.qvChoose.disabled = st.blocked || st.current;
      if (this.qvNote) { this.qvNote.textContent = st.note; this.qvNote.hidden = !st.note; }
      this.qv.hidden = false;
      document.documentElement.classList.add('mbp-lock');
      var self = this;
      requestAnimationFrame(function () {
        self.qv.classList.add('is-open');
        var c = self.qv.querySelector('.mbq__close');
        if (c) c.focus({ preventScroll: true });
      });
    }
    closeQuickView(silent) {
      if (!this.qv || this.qv.hidden) return;
      var self = this;
      this.qv.classList.remove('is-open');
      this.qv.hidden = true;
      this.qvBody.innerHTML = '';
      if (this.modal.hidden) document.documentElement.classList.remove('mbp-lock');
      if (!silent && this.qvOpener && this.qvOpener.isConnected) this.qvOpener.focus({ preventScroll: true });
    }
    closePopup() {
      if (!this.modal || this.modal.hidden) return;
      var self = this;
      this.modal.classList.remove('is-open');
      document.documentElement.classList.remove('mbp-lock');
      setTimeout(function () { self.modal.hidden = true; }, 200);
      if (this.opener && this.opener.isConnected && !this.opener.hidden) this.opener.focus({ preventScroll: true });
      else if (this.activeSlot && this.activeSlot.box.change) this.activeSlot.box.change.focus({ preventScroll: true });
    }
    choose(s, pid) {
      var entry = this.products[pid];
      if (!entry) return;
      var p = entry.data;
      if (this.pickState(p, s).blocked) return;
      var size = s.variant && s.variant.size;
      s.product = p;
      var card = (this.activeList && this.activeList.querySelector('[data-pid="' + pid + '"] [data-pick-card]')) || entry.picks[0].querySelector('[data-pick-card]');
      s.cardCopy = card ? this.staticCard(card) : null;
      s.variant = size ? p.variants.find(function (v) { return v.size === size && v.available; }) || null : null;
      if (!s.variant && p.variants.length === 1 && p.variants[0].available) s.variant = p.variants[0];
      this.closePopup();
      this.renderSlot(s);
      this.update();
      if (s.box.change) s.box.change.focus({ preventScroll: true });
    }

    /* ---------- slot ---------- */
    renderSlot(s) {
      var b = s.box;
      var p = s.product;
      s.node.classList.toggle('is-filled', !!p);
      if (b.empty) b.empty.hidden = !!p;
      if (b.actions) b.actions.hidden = !p;
      if (b.chosen) {
        b.chosen.hidden = !p;
        b.chosen.innerHTML = '';
        if (p && s.cardCopy) b.chosen.appendChild(s.cardCopy);
      }
      this.renderSizes(s);
    }
    /* Copy of the Eurus card shown in the popup, without its scripts, so it looks the same in the dress slot */
    staticCard(card) {
      var clone = card.cloneNode(true);
      /* Drop pieces that are hidden on the live card (loading layers, hover panels, buttons) */
      var src = [card].concat(Array.prototype.slice.call(card.querySelectorAll('*')));
      var dst = [clone].concat(Array.prototype.slice.call(clone.querySelectorAll('*')));
      var drop = [];
      src.forEach(function (n, i) {
        if (i === 0 || !dst[i]) return;
        var cs = window.getComputedStyle(n);
        if (n.hasAttribute('x-cloak') || cs.display === 'none' || cs.visibility === 'hidden' || (cs.opacity === '0' && n.tagName !== 'IMG' && !n.querySelector('img'))) drop.push(dst[i]);
      });
      drop.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      [clone].concat(Array.prototype.slice.call(clone.querySelectorAll('*'))).forEach(function (n) {
        Array.prototype.slice.call(n.attributes).forEach(function (a) {
          if (/^(x-|@|:)/.test(a.name)) n.removeAttribute(a.name);
        });
        if (n.id) n.removeAttribute('id');
      });
      clone.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      clone.querySelectorAll('.animate_transition_card__image, .animate_transition_image').forEach(function (el) { el.classList.add('active', 'lazy_active'); });
      clone.removeAttribute('data-pick-card');
      clone.classList.add('mbp-chosen__card');
      return clone;
    }
    renderSizes(s) {
      var self = this;
      var box = s.box.sizes;
      if (!box) return;
      box.innerHTML = '';
      if (s.box.sizeWrap) s.box.sizeWrap.hidden = !s.product;
      if (!s.product) return;
      /* Two rows at most on phones: half the sizes per row, rounded up */
      box.style.setProperty('--mbp-size-cols', Math.max(1, Math.ceil(s.product.variants.length / 2)));
      s.product.variants.forEach(function (v) {
        var btn = el('button', 'mbx-option' + (s.variant && s.variant.id === v.id ? ' is-selected' : '') + (v.available ? '' : ' is-soldout'), v.size);
        btn.type = 'button';
        btn.disabled = !v.available;
        btn.setAttribute('aria-pressed', s.variant && s.variant.id === v.id ? 'true' : 'false');
        btn.setAttribute('aria-label', v.size + (v.available ? '' : ', ' + self.t.soldOut));
        btn.addEventListener('click', function () {
          s.variant = v;
          self.renderSlot(s);
          self.update();
        });
        box.appendChild(btn);
      });
    }

    /* ---------- totals ---------- */
    cheapestIn(listId) {
      var self = this, best = null;
      if (!this.modal) return null;
      var list = this.modal.querySelector('[data-list="' + listId + '"]');
      if (!list) return null;
      list.querySelectorAll('[data-pick]').forEach(function (pick) {
        var e = self.products[pick.dataset.pid];
        if (!e) return;
        var v = firstAvailable(e.data);
        if (v && (!best || v.price < best.price)) best = v;
      });
      return best;
    }
    update() {
      var self = this;
      var regular = 0, needDress = [], needSize = [];
      this.slots.forEach(function (s) {
        var v = s.variant;
        if (!s.product) needDress.push(s.label);
        else if (!v) needSize.push(s.label);
        /* Only dresses that have been chosen count toward the total; empty dresses add 0 */
        if (!v && s.product) v = firstAvailable(s.product);
        if (v) regular += Number(v.price) || 0;
      });
      var complete = !needDress.length && !needSize.length && this.slots.length > 0;
      var sale = Math.round(regular * (1 - this.discount / 100));
      if (this.out.compare) { this.out.compare.textContent = formatMoney(regular, this.fmt); this.out.compare.hidden = this.discount <= 0; }
      if (this.out.price) this.out.price.textContent = formatMoney(sale, this.fmt);
      if (this.out.save) {
        this.out.save.textContent = this.t.save
          .replace('[amount]', formatMoney(regular - sale, this.fmt))
          .replace('[percent]', String(this.discount).replace(/\.0+$/, ''));
        this.out.save.hidden = this.discount <= 0;
      }
      if (this.out.note) this.out.note.hidden = !needSize.length;
      if (this.out.status && !this._busy && !this._keepStatus) {
        var msg = '';
        if (needDress.length) msg = this.t.chooseDress.replace('[items]', joinList(needDress));
        else if (needSize.length) msg = this.t.chooseSize.replace('[items]', joinList(needSize));
        this.out.status.textContent = msg;
        this.out.status.classList.remove('is-success', 'is-error');
      }
      this._keepStatus = false;
      this.complete = complete;
      if (this.button) this.button.disabled = !complete || !!this._busy;
    }

    /* ---------- cart ---------- */
    cartStore() {
      try { return window.Alpine && window.Alpine.store ? window.Alpine.store('xMiniCart') : null; }
      catch (e) { return null; }
    }
    async openEurusDrawer() {
      var store = this.cartStore();
      if (!store || typeof store.openCart !== 'function') return false;
      try { store.needReload = true; } catch (e) {}
      if (typeof store.reLoad === 'function') { try { await store.reLoad(); } catch (e) {} }
      store.openCart();
      return true;
    }
    /* Adds the section's discount code (e.g. TRAVEL30) to the cart, keeping any code already there.
       Shopify still checks the code's own rules (minimum items, eligible products) at checkout. */
    async applyDiscountCode(root) {
      var code = (this.dataset.discountCode || '').trim();
      if (!code) return;
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      try {
        var codes = [code];
        try {
          var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
          (cart.discount_codes || []).forEach(function (d) {
            if (d && d.code && codes.every(function (c) { return c.toLowerCase() !== d.code.toLowerCase(); })) codes.push(d.code);
          });
        } catch (e) {}
        var res = await fetch(root + 'cart/update.js', { method: 'POST', headers: headers, body: JSON.stringify({ discount: codes.join(',') }) });
        if (!res.ok) throw new Error('cart/update.js ' + res.status);
      } catch (err) {
        /* Fallback: Shopify's discount link saves the code for checkout */
        try { await fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); } catch (e) {}
      }
    }
    async addToCart() {
      if (!this.complete || this._busy) return;
      var self = this;
      var bundleId = 'MB' + Date.now().toString(36).toUpperCase();
      var name = this.dataset.bundleName || 'Bundle';
      var label = this.dataset.propertyLabel || 'Bundle';
      var items = this.slots.map(function (s) {
        var props = { _bundle: name, _bundle_id: bundleId };
        if (self.dataset.showProperty === 'true') props[label] = name;
        return { id: Number(s.variant.id), quantity: 1, properties: props };
      });
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this._busy = true;
      this.button.disabled = true;
      this.button.classList.add('is-loading');
      this.button.setAttribute('aria-busy', 'true');
      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message || this.t.error);
        await this.applyDiscountCode(root);
        document.dispatchEvent(new CustomEvent('mome:bundle-added', { detail: { bundleId: bundleId, items: items } }));
        var after = this.dataset.afterAdd || 'drawer';
        if (after === 'cart' || (after === 'drawer' && !(await this.openEurusDrawer()))) {
          window.location.href = root + 'cart';
          return;
        }
        this._keepStatus = true;
        this.out.status.textContent = this.t.success + ' ';
        var a = el('a', null, this.t.viewCart);
        a.href = root + 'cart';
        this.out.status.appendChild(a);
        this.out.status.classList.add('is-success');
      } catch (err) {
        this._keepStatus = true;
        this.out.status.textContent = err.message || this.t.error;
        this.out.status.classList.add('is-error');
      } finally {
        this._busy = false;
        this.button.classList.remove('is-loading');
        this.button.removeAttribute('aria-busy');
        this.update();
      }
    }
  }

  customElements.define('mome-bundle-picker', MomeBundlePicker);
})();